<template>
	<div class="container page">
		<van-nav-bar :title="$t('textS8')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="main">
			<van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
			<div v-else class="item_list" v-for="(v,key) in list" :key="key">
				<div class="lottery_info">
					<van-image class="cover" :src="v.image">
						<template v-slot:loading>
							<van-loading type="spinner" />
						</template>
					</van-image>
					<!-- <span class="period-number">{{v.expect}}</span> -->
					<span class="period-number">{{v.name}}</span>
				</div>

				<div class="topInfo" style="padding-top: 10px;">
					<span>{{$t('other.period_number')}}：{{v.period}}</span>
				</div>
				<div class="topInfo" style="padding-top: 10px;">
					<span>{{$t('other.order_points')}}：{{v.amount}}</span>
				</div>
				<div class="topInfo" style="padding-top: 10px;">
					<span>{{$t('other.order_data')}}：{{v.options}}</span>
				</div>
				<div class="topInfo" style="padding-top: 10px;">
					{{$t('other.profit_loss')}}：
					<span :style="{color:v.profit_status==1?'#44a145':'#f92672'}">{{v.profit_amount}}</span>
				</div>

				<!-- <div class="recent">
					<div class="kuaisan-ball left">
						<div>
							<span>{{$t("Đặt hàng dữ liệu")}}</span>
							<span class="ressquareBox" v-for="(item,index) in v.options" :key="index">{{  item }}</span>
						</div>
					</div>
				</div> -->
				<div class="time">
					<span>{{$t('other.order_time')}}：{{v.completetime_text}}</span>
				</div>
				<div class="time">
					<span>{{$t('other.settle_time')}}：{{v.createtime_text}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				list: [],
				sum: '',
				double: '',
				size: ""

			};
		},
		created() {
			this.getUserGameList();
		},
		methods: {
			back() {
				return window.history.back();
			},
			// onRefresh() {
			// 	setTimeout(() => {
			// 		this.$toast(this.$t("reservation.refresh"));
			// 		this.isLoading = false;
			// 	}, 500);
			// },
			getUserGameList() {
				this.$http({
					method: 'get',
					url: 'getLotteryOrderHistory'
				}).then(res => {
					if (res.code == 1) {

						this.list = res.data;

					} else {
						this.$toast(res.msg);
					}
				})
			}

		},


	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		background-color: #f2f2f5;
		height: 100%;
		padding: 0 10px;
	}

	.item_list {
		padding: 15px 15px;
		margin: 30px 10px;
		background: #fff;
		border-radius: 10px;
		line-height: 60px;
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 32px;
		font-weight: 700;
		color: #000;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #000;
	}

	.item_list .topInfo span:last-child {}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}

	.item_list .cover {
		width: 60px;
		height: 60px;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.item_list .period-number {
		margin-left: 50px;
		margin-right: 10px;
		height: 50px;
		line-height: 60px;
		font-size: 35px;
		font-weight: 700;
		color: #000;
	}

	.item_list .lottery_info {
		display: flex;
	}

	.recent {
		display: flex;
		align-items: center;
		height: 100px;
	}

	.kuaisan-ball .left {
		justify-content: flex-start;
	}

	.kuaisan-ball {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.kuaisan-ball .res-img {
		width: 70px;
		height: 70px;
		margin-right: 30px;
	}

	.kuaisan-ball .res-des {
		font-weight: 700;
		text-align: center;
		color: #000;
	}

	.kuaisan-ball .res-des.middle {
		width: 15%;
		font-size: 35px;
	}

	.ressquareBox {
		background: linear-gradient(90deg, #f560cd, #4f2b8a);
		color: #fff;
		height: 7vw;
		line-height: 7vw;
		text-align: center;
		font-size: 3vw;
		font-weight: 700;
		border-radius: 16px;
		margin-left: 20px;
		padding: 13px 40px;
		min-width: 13vw;
	}
</style>